import React from 'react';

import {
  trackPartnerImpression,
  trackPartnerLogoClick,
  trackPartnerNameClick,
  trackStorefrontClick,
  trackVisitShopClick,
} from '../tracking/partnerMaxiModuleEvents';
import type { PartnerMaxiModuleProps } from './PartnerMaxiModule';
import { PartnerMaxiModule } from './PartnerMaxiModule';

export interface PartnerMaxiModuleContainerProps extends PartnerMaxiModuleProps {
  partnerShortcode: string;
}

export const PartnerMaxiModuleWithTracking = ({
  partnerShortcode,
  ...restOfProps
}: PartnerMaxiModuleContainerProps) => {
  return (
    <PartnerMaxiModule
      {...restOfProps}
      onLogoClick={(e) => trackPartnerLogoClick(e, partnerShortcode)}
      onPartnerNameClick={(e) => trackPartnerNameClick(e, partnerShortcode)}
      onStorefrontClick={trackStorefrontClick}
      onVisible={() => trackPartnerImpression(partnerShortcode)}
      onVisitShopClick={(e) => trackVisitShopClick(e, partnerShortcode)}
    />
  );
};
